module.exports = __webpack_public_path__ + "static/testimonials-2-f3c0271e2279f2bdeea02ddc3aa03dc5.jpg";